document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("form#ContactForm");
  if (!form) return;

  // prevent double-binding if Shopify reloads sections in theme editor
  if (form.dataset.cartSyncBound === "1") return;
  form.dataset.cartSyncBound = "1";

  form.addEventListener("submit", async (e) => {
    const hidden = document.querySelector("#CartContentsForContact");
    if (!hidden) return; // if you don't have the hidden field, don't block submit

    e.preventDefault();

    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      let text = "--- Warenkorb ---\n";

      cart.items.forEach((item) => {
        text += `${item.quantity} x ${item.product_title}`;

        if (item.variant_title && item.variant_title !== "Default Title") {
          text += ` - ${item.variant_title}`;
        }

        if (item.properties) {
          Object.entries(item.properties).forEach(([k, v]) => {
            if (v !== null && v !== "" && v !== "null") {
              text += ` | ${k}: ${v}`;
            }
          });
        }

        text += "\n";
      });

      hidden.value = text;
    } catch (err) {
      // fail open
    }

    form.submit();
  });
});
